export default __webpack_public_path__ + "static/media/sample-grid-european.bf3a6c1c.svg";